import {ComponentType, LazyExoticComponent, lazy} from 'react'

import {importWithRetry} from './chunkLoad'

/**
 * `React.lazy` whose import is retried in place when the chunk fails to load (flaky
 * network), before ChunkErrorBoundary falls back to reloading the page. Use it for
 * every lazy component — React.lazy caches a rejected import for good, so a single
 * dropped request would otherwise cost the user a full page reload.
 *
 * @param factory The usual `() => import('./Page')` loader.
 * @returns A lazy component, exactly as `React.lazy` would return.
 */
export const lazyWithRetry = <T extends ComponentType<any>>(
  factory: () => Promise<{default: T}>
): LazyExoticComponent<T> => lazy(() => importWithRetry(factory))
